module.exports = __webpack_public_path__ + "static/media/demo.a8d1db13.png";